import { render, staticRenderFns } from "./support.vue?vue&type=template&id=f178ca0c&scoped=true&"
import script from "./support.vue?vue&type=script&lang=ts&"
export * from "./support.vue?vue&type=script&lang=ts&"
import style0 from "./support.vue?vue&type=style&index=0&id=f178ca0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f178ca0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VDivider})
